import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 403,
  name: 'Forbidden',
  description:
    'The server understood the request but refuses to authorize it. Unlike 401, the client\'s identity is known — they simply do not have permission to access this resource.',
  causes: [
    'The authenticated user does not have the required role or permission to access the resource.',
    'IP-based access control or a Web Application Firewall (WAF) is blocking the request based on the client\'s IP address or geographic location.',
    'File system permissions on the server prevent the web server process from reading the requested file or directory.',
  ],
  fixes: [
    'Check the user\'s roles and permissions. Ensure the account has the required access level for the resource.',
    'If blocked by a WAF or IP whitelist, add the client\'s IP address to the allow list or adjust firewall rules.',
    'On the server, verify file permissions (e.g., chmod 644 for files, 755 for directories) and ensure the web server user owns or can read the files.',
  ],
  monitoringTip:
    'If a public page suddenly returns 403, it usually means a misconfigured firewall rule or permissions change. Uptrack detects this within 30 seconds and alerts you once several locations confirm it, so you can revert before users are locked out.',
}

export const Route = createFileRoute('/_site/http/403')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
